import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

export default function PackagingDayHistoryModal({
  open,
  setOpen,
  date,
  formattedDate,
  items = [],
  loading = false,
  onRefresh,
  onView,
  analytics,
}) {
  const header = (
    <div className="flex items-center justify-between w-full">
      <div className="font-semibold">Packaging history - {formattedDate}</div>
      <div className="flex items-center gap-3 mr-5">
        <Button
          label="Refresh"
          className="p-button-sm"
          onClick={() => onRefresh && onRefresh()}
        />
        <Button
          label="Close"
          className="p-button-sm p-button-secondary"
          onClick={() => setOpen(false)}
        />
      </div>
    </div>
  );

  const timeBody = (rowData) =>
    rowData.time || new Date(rowData.production_date).toLocaleTimeString();

  const actionsBody = (rowData) => {
    if (!rowData || !rowData.id)
      return <span className="text-sm text-gray-500">No details</span>;
    return (
      <a
        href={`/packaging/${rowData.id}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Open packaging ${rowData.id} in new tab`}
        className="inline-flex items-center rounded-md bg-main-purple px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 whitespace-nowrap"
      >
        View details
      </a>
    );
  };

  const stockBody = (rowData) => {
    const val = rowData.stock_in_weight;
    // round val to two decimals
    const roundedVal = Number(val).toFixed(2);
    return `${roundedVal} kg`;
  };
  return (
    <Dialog
      visible={open}
      onHide={() => setOpen(false)}
      style={{ width: "80vw" }}
      header={header}
      modal
      closable={false}
    >
      {loading ? (
        <div className="text-center py-10">Loading...</div>
      ) : items.length === 0 ? (
        <div className="text-center py-10 text-gray-600">
          No packaging runs for this date.
        </div>
      ) : (
        <div>
          <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {(() => {
              const stats = analytics.stats;

              return (
                <>
                  <div className="p-4 bg-white border rounded-md shadow-sm">
                    <div className="text-sm text-gray-500">
                      Total Packed Unit
                    </div>
                    <div className="mt-1 text-2xl font-semibold text-gray-900">
                      {stats[0].stat}
                    </div>
                  </div>
                  <div className="p-4 bg-white border rounded-md shadow-sm">
                    <div className="text-sm text-gray-500">
                      Total Packed Weight
                    </div>
                    <div className="mt-1 text-2xl font-semibold text-gray-900">
                      {stats[1].stat}
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
          <DataTable
            value={items}
            responsiveLayout="scroll"
            className="p-datatable-sm"
            paginator
            rows={10}
          >
            <Column header="Time" body={timeBody} />
            <Column field="product_name" header="Product" />
            <Column field="new_lot_number" header="Lot" />
            <Column field="serial_number" header="Serial" />
            <Column field="total_individual_units" header="Total Packed" />
            <Column header="Total Packaged" body={stockBody} />
            {/* <Column
            header="Actions"
            body={actionsBody}
            style={{ width: "120px" }}
          /> */}
          </DataTable>
        </div>
      )}
    </Dialog>
  );
}
